import { Typography } from '@mgmresorts/wcl-lab';
import React, { useCallback, useContext, useState } from 'react';

import { ManualAddressForm } from '../../../components/ui/Inputs/ManualAddressForm';
import { NavigationLink } from '../../../components/ui/Link';
import { useContent } from '../../../hooks/useContent';
import PlacesPredictionsList from '../PlacesPredictionsList';
import { SignUpFormContext } from '../SignUpFormContext';

import StyledContent from './StyledContent';

export function Address() {
  const [useManualEntry, setManualEntry] = useState(false);
  const {
    bindAddress,
    bindAddress2,
    bindCity,
    bindZip,
    bindState,
    bindCountry,
    bindCustomState,
    isLoading,
    invalidFields,
    resetAddress,
    resetAddress2,
    resetCity,
    resetState,
    resetCustomState,
    resetZip,
    removeInvalidField,
    setInvalidField,
  } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();

  const resetFields = useCallback(() => {
    resetAddress();
    resetAddress2();
    resetCity();
    resetState();
    resetZip();
  }, [resetAddress, resetAddress2, resetCity, resetState, resetZip]);

  const toggleManualEntry = useCallback(() => {
    resetFields();
    setManualEntry(manual => !manual);
  }, [resetFields]);

  return (
    <StyledContent>
      <div className='identity__address-wrapper'>
        <Typography variant='h5' className='identity__address-title'>
          {getContentByPath('accountCreation.fields.address.title')}
        </Typography>
        {useManualEntry ? (
          <>
            <ManualAddressForm
              {...{
                bindAddress,
                bindAddress2,
                bindCity,
                bindZip,
                bindState,
                resetState,
                resetCustomState,
                bindCountry,
                bindCustomState,
                isLoading,
                invalidFields,
                removeInvalidField,
                setInvalidField,
              }}
            />
            <Typography variant='small'>
              <NavigationLink onClick={toggleManualEntry} path='#'>
                {getContentByPath('accountCreation.fields.address.prediction.insertPrediction')}
              </NavigationLink>
            </Typography>
          </>
        ) : (
          <PlacesPredictionsList onManualEntrySelection={toggleManualEntry} />
        )}
      </div>
    </StyledContent>
  );
}
